import { render, staticRenderFns } from "./Adam6066ConfigPage.vue?vue&type=template&id=a647ddce&"
import script from "./Adam6066ConfigPage.vue?vue&type=script&lang=js&"
export * from "./Adam6066ConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./Adam6066ConfigPage.vue?vue&type=style&index=0&id=a647ddce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports